import { Outlet, useNavigate } from 'react-router-dom';
import { Logo } from '../../components/brand/Logo';
import { useAuthStore } from '../../store/auth';

/** Zero-distraction full-screen shell for the mandatory onboarding flow — the
 * app chrome (nav, bell, menu) is deliberately absent. Mirrors AuthLayout. A
 * single "Finish later" escape hatch signs the user out without losing progress
 * (onboarding resumes at the persisted step on next sign-in), so a user blocked
 * on a step is never trapped with no way out. */
export function OnboardingLayout() {
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();
  const finishLater = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="relative flex min-h-screen flex-col items-center px-6 py-12">
      {/* Ambient green glow — the eye watching from the dark. */}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 -z-10"
        style={{
          background: 'radial-gradient(60% 50% at 50% 0%, var(--iris-dim), transparent 70%)',
        }}
      />
      <button
        type="button"
        onClick={() => void finishLater()}
        className="fixed right-5 top-5 rounded-sm px-2 py-1 text-xs text-muted transition-colors hover:text-bone"
        title="Sign out and finish later — you'll resume right where you left off."
      >
        Finish later →
      </button>
      <div className="mb-10 flex justify-center">
        <Logo size={30} />
      </div>
      <div className="w-full max-w-3xl">
        <Outlet />
      </div>
    </div>
  );
}
